import type { CheckboxProps } from '@mui/material'
import { Checkbox } from '@mui/material'
import React from 'react'
import ParentCellOrFragment from './ParentCellOrFragment'

type CheckboxCellProps = {
  disableCell?: boolean
} & CheckboxProps

export const CHECKBOX_CELL_WIDTH = 20

const CheckboxCell: React.FC<CheckboxCellProps> = ({ disableCell, ...props }) => {
  return (
    <ParentCellOrFragment disableCell={disableCell} width={CHECKBOX_CELL_WIDTH}>
      <Checkbox data-testid="checkbox-cell" color="primary" size="medium" sx={{ p: 0, mx: 0.5 }} {...props} />
    </ParentCellOrFragment>
  )
}

export default CheckboxCell
